import * as React from 'react';

var _mask, _g, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Search_svg__a",
    width: 14,
    height: 14,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    d: "M1.09 1h12.078v12.116H1.09V1z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    mask: "url(#Search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.13 1.933c-2.818 0-5.11 2.299-5.11 5.125s2.292 5.125 5.11 5.125c2.816 0 5.108-2.3 5.108-5.125 0-2.826-2.292-5.125-5.108-5.125m0 11.183c-3.33 0-6.04-2.718-6.04-6.058S3.8 1 7.13 1s6.038 2.717 6.038 6.058c0 3.34-2.708 6.058-6.038 6.058",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13 1.433c-3.095 0-5.61 2.524-5.61 5.625h1c0-2.552 2.07-4.625 4.61-4.625v-1zM1.52 7.058c0 3.1 2.515 5.625 5.61 5.625v-1c-2.54 0-4.61-2.074-4.61-4.625h-1zm5.61 5.625c3.094 0 5.608-2.525 5.608-5.625h-1c0 2.551-2.07 4.625-4.608 4.625v1zm5.608-5.625c0-3.101-2.514-5.625-5.608-5.625v1c2.539 0 4.608 2.073 4.608 4.625h1zM7.13 12.616c-3.053 0-5.54-2.493-5.54-5.558h-1c0 3.615 2.932 6.558 6.54 6.558v-1zM1.59 7.058C1.59 3.992 4.077 1.5 7.13 1.5v-1C3.522.5.59 3.442.59 7.058h1zM7.13 1.5c3.052 0 5.538 2.492 5.538 5.558h1C13.668 3.442 10.738.5 7.13.5v1zm5.538 5.558c0 3.065-2.486 5.558-5.538 5.558v1c3.607 0 6.538-2.943 6.538-6.558h-1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M14.178 15.684a.683.683 0 01-.481-.213l-3.155-3.319a.695.695 0 01.022-.978.687.687 0 01.974.022l3.155 3.32a.692.692 0 01-.515 1.168",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M14.178 15.684a.683.683 0 01-.481-.213l-3.155-3.319a.695.695 0 01.022-.978.687.687 0 01.974.022l3.155 3.32a.692.692 0 01-.515 1.168"
  })));
}

export { SvgSearch as ReactComponent };
//# sourceMappingURL=Search.svg.js.map
